<div
  [mmTestState]="isSuggestionsListVisible ? 'active' : 'inactive'"
  [@fadeInOut]="isSuggestionsListVisible"
  class="suggestion-list"
  fxLayout.mm-mobile="column nowrap"
  fxLayout="row wrap">
  <div
    class="suggestion-list__text"
    fxLayout="column nowrap"
    fxFlex="1 1 100%">
    <ng-container *ngIf="isSuggestionsListVisible
      && (!searchQuery || searchQuery.length === 0)
      && historyTerms && historyTerms.length > 0">
      <app-generic-suggestion-item
        *ngFor="let item of historyTerms | slice: 0 : itemsToShow; even as even"
        [mmTestId]="'BUYER_PAGES.SUGGESTION_ITEM'"
        fxFlex="100"
        fxFlex.mm-mobile="0 0 auto"
        fxLayout="row wrap"
        fxLayoutAlign="flex-start center"
        (historyRemoved)="historyRemoved.emit($event)"
        (termSelected)="termSelected.emit($event)"
        [isHistory]="true"
        [suggestion]="item">
      </app-generic-suggestion-item>
    </ng-container>

    <ng-container *ngIf="isSuggestionsListVisible
      && searchQuery && searchQuery.length > 0
      && suggestions && suggestions.length > 0">
      <app-generic-suggestion-item
        class="suggestion-item-wrapper"
        [mmTestId]="'BUYER_PAGES.SUGGESTION_ITEM'"
        fxFlex="100"
        fxFlex.mm-mobile="0 0 auto"
        fxLayout="row wrap"
        fxLayoutAlign="flex-start center"
        *ngFor="let suggestion of suggestions | slice: 0 : itemsToShow; even as even"
        (termSelected)="termSelected.emit($event)"
        [suggestion]="suggestion"
        [searchQuery]="searchQuery">
      </app-generic-suggestion-item>
    </ng-container>
  </div>

  <ng-container *ngIf="isSuggestionsListVisible
      && searchQuery && searchQuery.length > 0
      && suggestionsProducts && suggestionsProducts.length > 0">
    <a
      class="products-divider"
      (click)="promoClick.emit(true)"
      [routerLink]="searchRoute"
      [queryParams]="{
          'f.promotion': true,
          'q': searchQuery
        }">
      <span [innerHTML]="'HEADER.ALL_PAGES.HEADER.SUGGESTIONS.TO_PROMO' | translate"></span>
      <mm-icon class="arrow-right" name="arrow-right-ico"></mm-icon>
    </a>

    <div
      class="suggestion-list__products"
      fxLayout.mm-mobile="column nowrap"
      fxLayout="row wrap">
      <app-search-product-suggestion
        fxFlex="100"
        fxFlex.mm-mobile="0 0 auto"
        fxLayout="row wrap"
        fxLayoutAlign="flex-start center"
        *ngFor="let product of suggestionsProducts | slice: 0 : productsToShow"
        (productClicked)="productSelected.emit($event)"
        [product]="product">
      </app-search-product-suggestion>
    </div>
  </ng-container>
  <ng-container *ngIf="isSuggestionsListVisible">
    <button class="suggestion__search-by-image" [attr.aria-label]="'HEADER.ALL_PAGES.HEADER.SUGGESTIONS.SEARCH_BY_PHOTO.TEXT' | translate" (click)="onSearchByPhotoSuggestionClicked($event)">
      <span class="suggestion__search-by-image-icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" stroke="none">
        <rect x="0.75" y="2.25" width="18.5" height="16.5" rx="2.25" stroke="#0059E4" stroke-width="1.5"
              stroke-linejoin="bevel"></rect>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M17 3H3C2.17157 3 1.5 3.67157 1.5 4.5V16.5C1.5 17.3284 2.17157 18 3 18H17C17.8284 18 18.5 17.3284 18.5 16.5V4.5C18.5 3.67157 17.8284 3 17 3ZM3 1.5C1.34315 1.5 0 2.84315 0 4.5V16.5C0 18.1569 1.34315 19.5 3 19.5H17C18.6569 19.5 20 18.1569 20 16.5V4.5C20 2.84315 18.6569 1.5 17 1.5H3Z"
              fill="#0059E4"></path>
        <rect x="10" y="0.5" width="6" height="1.5" rx="0.75" fill="#0059E4"></rect>
        <circle cx="10" cy="10.5" r="4.25" stroke="#0059E4" stroke-width="1.5"></circle>
      </svg>
      </span>
      <span>{{'HEADER.ALL_PAGES.HEADER.SUGGESTIONS.SEARCH_BY_PHOTO.TEXT' | translate}}</span>
      <app-new-badge></app-new-badge>
    </button>
    <input #searchByPhotoInput id="search-file-input" type="file" accept=".jpg,.jpeg,.png,.webp.webp,android/force-camera-workaround"
           class="search-photo-modal-file-input" (change)="handlePhotoSearch($event)">
  </ng-container>
</div>
